import vueConfig from '../../config/vueConfig'

var adminPath = vueConfig.adminUrl;
export default {
    adminPages: [
        //#自动adminPath#
        {path: adminPath + "/expensesInfo", component: () => import("./expensesInfo_index.vue")},
        {path: adminPath + "/kfgzt", component: () => import("./kfgzt_index.vue")},
        {path: adminPath + "/gsfStatistical", component: () => import("./gsfStatistical_index.vue")},
        {path: adminPath + "/goodAvgStatistical", component: () => import("./goodAvgStatistical_index.vue")},
    ],
    pages: []
}
